import React from "react";

export const AdminStats = ({ stats }) => {
  if (!stats) {
    return null;
  }

  const items = [
    { id: "total", label: "Total tutores", value: stats.tutors_total, accent: false },
    { id: "pending", label: "Pendientes", value: stats.tutors_pending, accent: true },
    { id: "sessions", label: "Clases", value: stats.sessions_total, accent: false },
  ];

  return (
    <div className="mt-10 grid grid-cols-3 gap-4 lg:gap-8 max-w-[720px]">
      {items.map((item) => (
        <div key={item.id} data-testid={`admin-stat-${item.id}`}>
          <div className="text-[11px] uppercase tracking-[0.14em]" style={{ color: "#70667A" }}>
            {item.label}
          </div>
          <div
            className="font-mono-num text-[28px] font-bold tracking-hero mt-1"
            style={{ color: item.accent ? "#7228C8" : "#1E1924" }}
          >
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};